import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles({
  loadMoreButton: {
    border: "1px solid",
    margin: "20px 0",
    color: "black",
  },
});
